import { loyaltyLinks } from "../../../components/lib/SidebarLinks";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Layout2 from "@/components/Layout/Layout2";
import LeftBar2 from "@/components/Layout/LeftBar2";
import { Plus } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Separator } from "@radix-ui/react-separator";
import { useDispatch, useSelector } from "react-redux";
import { useCallback, useEffect, useRef, useState } from "react";
import useAuth from "@/hooks/useAuth";
import useDebounce from "@/hooks/useDebounce";
import TableSkeleton from "@/components/skeleton/table-skeletion";
import PointBasedRewardHistoryTab from "@/components/loyalty/pointBasedReward/PointBasedRewardHistoryTab";
import PointBasedRewardTab from "@/components/loyalty/pointBasedReward/PointBasedRewardTab";
import { fetchPointBasedOffer, setCurrentPage, setStatus, setVoucherSearch } from "@/redux/slice/loyalty/PointBasedOfferSlice";
import { fetchPointBasedOfferHistories, setVoucherHistoryCurrentPage, setVoucherHistorySearch, setVoucherHistoryStatus } from "@/redux/slice/loyalty/PointBasedOfferHistorySlice";
import hasPermission from "@/hooks/hasPermission";

function PointBasedOffer() {
  const location = useLocation();
  const isRouteCleanup = useRef(false);
  const { user } = useAuth();
  const dispatch = useDispatch();

  const { search, getLoading, status, perPage, currentPage } = useSelector(
    (state) => state.loyalty.pointBasedOffer
  );
  const { searchVoucherHistory, getVoucherHistoryLoading, voucherHistoryStatus, voucherHistoryPerPage, voucherHistoryCurrentPage } = useSelector(
    (state) => state.loyalty.pointBasedOfferHistory
  );
  const debouncedSearch = useDebounce(search, 900);
  const voucherHistoryDebouncedSearch = useDebounce(searchVoucherHistory, 900);

  useEffect(() => {
    return () => {
      isRouteCleanup.current = true;

      dispatch(setVoucherSearch(""));
      dispatch(setStatus(""));
      dispatch(setCurrentPage(1));

      dispatch(setVoucherHistorySearch(""));
      dispatch(setVoucherHistoryStatus(""));
      dispatch(setVoucherHistoryCurrentPage(1));

      // next mount-এর জন্য reset
      setTimeout(() => {
        isRouteCleanup.current = false;
      }, 0);
    };
  }, [location.pathname]);
  useEffect(() => {
    const query = {
      page: currentPage,
      per_page: perPage,
      search: debouncedSearch,
      restaurant_id: user?.restaurant_id,
    };

    if (status && status !== "0") {
      query.status = status;
    }

    dispatch(fetchPointBasedOffer(query));
  }, [currentPage, debouncedSearch, status, perPage]);

  useEffect(() => {
    const query = {
      page: voucherHistoryCurrentPage,
      per_page: voucherHistoryPerPage,
      search: voucherHistoryDebouncedSearch,
      restaurant_id: user?.restaurant_id,
    };

    if (voucherHistoryStatus && voucherHistoryStatus !== "0") {
      query.status = voucherHistoryStatus;
    }

    dispatch(fetchPointBasedOfferHistories(query));
  }, [voucherHistoryCurrentPage, voucherHistoryDebouncedSearch, voucherHistoryStatus, voucherHistoryPerPage]);

  if (getLoading) return <TableSkeleton links={loyaltyLinks} />;

  return (
    <Layout2
      pageName={{ title: "Point-Based Reward" }}
      paths={[
        { name: "Loyalty", path: "/loyalty" },
        { name: "Point-Based Reward" },
      ]}
      LeftBar={<LeftBar2 sidebarLinks={loyaltyLinks} />}
    >
      <div className="container flex flex-col gap-6">
        <div className="flex justify-end items-start md:items-center md:flex-row flex-col w-full -mb-14">
          {hasPermission("loyalty_offer.point_based_offer.create_point_offer") && (
            <Link to={"/loyalty/point-based/add"}>
              <Button>
                <Plus /> Point-Based Reward
              </Button>
            </Link>
          )}
        </div>
        <Tabs valueKey="point-based" className="bg-transparent relative mt-8" defaultValue="pointBasedReward">
          <TabsList className="grid grid-cols-6 w-full">
            <Separator className="absolute top-8 " />
            <TabsTrigger className="bg-transparent" value="pointBasedReward">
              Point-Based Reward
            </TabsTrigger>
            <TabsTrigger value="pointBasedRewardHistory">Point-Based Reward History</TabsTrigger>
          </TabsList>
          <Separator className=" absolute top-8 w-full h-[1px] bg-neutral-700" />
          <PointBasedRewardTab />
          <PointBasedRewardHistoryTab />
        </Tabs>
      </div>
    </Layout2>
  );
}

export default PointBasedOffer;